<template>
  <v-app>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import router from './router'
import { HTTP } from './common/http'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  beforeCreate () {
    if (!this.$store.getters.IS_LOGGED) {
      router.push('/login')
    }

    if (window.location.pathname.split('/')[1]) {
      HTTP.post('/viewonly', {
          username: window.location.pathname.split('/')[1]
        }).then(response => {
          if (response.status === 200) {
            localStorage.setItem('id', response.data.id)
            localStorage.setItem('role', 'viewonly')
            localStorage.setItem('name', response.data.name)
            localStorage.setItem('logo', response.data.logo)
            localStorage.setItem('wmsUrl', response.data.wmsUrl)
            localStorage.setItem('wmsLayer', response.data.wmsLayer),
            localStorage.setItem('center', response.data.center),
            this.$store.commit('setUserInfo', response.data)
            router.push('/')
          }
        }).catch(err => console.error(err))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue